import { forwardRef } from 'react';
import { cn } from '../../lib/cn';
import { Spinner } from './spinner';

const SIZES = {
  sm: 'h-8 px-3 text-xs gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-6 text-sm gap-2',
  icon: 'h-10 w-10',
  'icon-sm': 'h-8 w-8',
};

const VARIANT_BASE =
  'relative inline-flex items-center justify-center rounded-xl font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97]';

function variantStyles(variant) {
  switch (variant) {
    case 'primary':
      return {
        background: 'linear-gradient(135deg, #ad34fe 0%, #7b1fd4 100%)',
        color: '#fff',
        border: '1px solid rgba(173,52,254,0.4)',
        boxShadow:
          '0 0 24px rgba(173,52,254,0.28), 0 4px 16px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.18)',
      };
    case 'secondary':
      return {
        background: 'var(--dash-surface)',
        color: 'var(--dash-text)',
        border: '1px solid var(--dash-border-strong)',
        boxShadow: 'var(--dash-shadow-sm)',
      };
    case 'outline':
      return {
        background: 'transparent',
        color: 'var(--dash-text)',
        border: '1px solid var(--dash-border-strong)',
      };
    case 'ghost':
      return {
        background: 'transparent',
        color: 'var(--dash-text-soft)',
        border: '1px solid transparent',
      };
    case 'danger':
      return {
        background: 'rgba(254,52,86,0.10)',
        color: '#d61f3f',
        border: '1px solid rgba(254,52,86,0.30)',
      };
    case 'danger-solid':
      return {
        background: 'linear-gradient(135deg, #fe3456 0%, #c41a36 100%)',
        color: '#fff',
        border: '1px solid rgba(254,52,86,0.5)',
        boxShadow: '0 0 18px rgba(254,52,86,0.28)',
      };
    default:
      return {};
  }
}

export const Button = forwardRef(function Button(
  {
    className,
    style,
    variant = 'secondary',
    size = 'md',
    loading = false,
    disabled,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    children,
    type = 'button',
    ...props
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(VARIANT_BASE, SIZES[size], className)}
      style={{ ...variantStyles(variant), ...style }}
      {...props}
    >
      {loading ? (
        <Spinner size={size === 'sm' ? 12 : 14} />
      ) : (
        LeftIcon && <LeftIcon size={size === 'sm' ? 14 : 16} strokeWidth={2.2} />
      )}
      {children && <span className="truncate">{children}</span>}
      {RightIcon && !loading && (
        <RightIcon size={size === 'sm' ? 14 : 16} strokeWidth={2.2} />
      )}
    </button>
  );
});
